const STORAGE_KEY = "tarazum-consent";
const FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap";

function loadFont() {
  if (document.querySelector("link[data-tarazum-font]")) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = FONT_HREF;
  link.dataset.tarazumFont = "true";
  document.head.appendChild(link);
}

function applyChoice(choice: string) {
  if (choice === "accepted") loadFont();
  document.querySelectorAll(".cookie-banner").forEach((banner) => {
    banner.setAttribute("hidden", "");
  });
}

export function initConsent() {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === "accepted" || saved === "rejected") {
    applyChoice(saved);
    return;
  }

  document.querySelectorAll(".cookie-banner").forEach((banner) => {
    banner.removeAttribute("hidden");
    banner.addEventListener("click", (event) => {
      const target = event.target as HTMLElement | null;
      const choice = target?.closest("button")?.getAttribute("data-consent");
      if (choice !== "accepted" && choice !== "rejected") return;
      localStorage.setItem(STORAGE_KEY, choice);
      applyChoice(choice);
    });
  });
}
